import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICombinedReplaceIdStatistic } from 'src/app/shared/interfaces/combined-replace-id-statistic.interface';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { TaskItemMapper } from 'src/app/shared/mappers/task-item.mapper';
import { TaskItemService } from '../../services/task-item.service';

@Component({
    standalone: false,
    selector: 'app-replace-land-use-ids-details-view',
    templateUrl: './replace-land-use-ids-details-view.component.html',
    styleUrls: ['./replace-land-use-ids-details-view.component.scss']
})
export class ReplaceLandUseIdsDetailsViewComponent implements OnInit {
    @Input()
    process: ITaskModel;

    combinedReplaceIdStatistics: ICombinedReplaceIdStatistic[] = [];

    constructor(private readonly router: Router, private readonly taskItemService: TaskItemService) {}

    ngOnInit(): void {
        if (!this.process) {
            return;
        }
        const mapper = new TaskItemMapper();
        this.taskItemService.getTaskItems(this.process.state, this.process.id).subscribe(data => {
            this.combinedReplaceIdStatistics = data.taskItems.map(dto => mapper.toCombinedReplaceIdStatistic(dto));
        });
    }

    deleteProcess(isDeleteProcess: boolean): void {
        if (isDeleteProcess) {
            this.router.navigate([`/instances/jobs`]);
        }
    }
}
